/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import Filters from "../../components/Filters";
import { ControlTable } from "../../components/Table";
import { get, isEmpty } from "lodash";
import { downExcelFile } from "../../utils/download";
import {
  deleteMappingGroup,
  getAccountsAllList,
  // deleteAccounts,
  getAccountsDownloadExcel,
} from "../../apis/companies/account";
import { CLIENT_SEARCH_OPTIONS, CLIENT_TYPES } from "../../constants/CLIENT";
import Client from "./Client";
import { viewLoading } from "../../utils/loading";
import useForm from "../../hooks/useForm";
import { getParams } from "../../utils/params";
import { shallowEqual, useSelector } from "react-redux";
import { clientPreview } from "../../utils/client";

import ClientFileUpload from "./ClientFileUpload.js";
import ClientOtherFileUpload from "./ClientOtherFileUpload";
import DeleteIcon from "../../assets/images/icon/delete-icon-01.svg";
import IconButton from "../Button/IconButton";
import systemAlert from "../../utils/systemAlert";

const Clients = ({ tabList, activeTab, targetPermission }) => {
  const { previewClient } = useSelector((store) => ({
    previewClient: store.Client.previewClient,
  }), shallowEqual);
  const [fields, setFields] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);

  const [fileUploadOpen, setFileUploadOpen] = useState(false);
  const [otherFileUploadOpen, setOtherFileUploadOpen] = useState(false);


  const [filters] = useState([
    {
      title: "분류",
      type: "select",
      key: "searchType",
      options: {
        list: CLIENT_SEARCH_OPTIONS,
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      placeholder: "검색어 입력",
    },
    {
      title: "그룹 검색",
      tyle: "input",
      key: "search.groupName",
      placeholder: "그룹명 입력",
    },
  ]);

  const handleRemoveMapping = (data, group) => {
    const companyAccountIdx = data.idx;
    const companyAccountGroupIdx = group.idx;

    systemAlert(`${data.name} 에 매핑된 그룹 [${group.name}]를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            deleteMappingGroup({
              companyAccountIdx,
              companyAccountGroupIdx
            })
              .then(() => {
                reSubmit();
              })
              .catch(() => { })
              .finally(() => { });
          }
        }
      ]
    });
  };

  useEffect(() => {
    setFields([
      {
        title: "등록일자",
        key: "createdTime",
        type: "date",
      },
      {
        title: "그룹", key: "companyAccountGroups", onValue: (v, _f, d) => {
          return (
            !isEmpty(v) && (
              v.map((item, idx) => {
                return (
                  <p className="pt-8 pb-8" key={idx}>
                    <span className="vertical-middle">
                      {item.name}
                    </span>
                    {targetPermission.level > 1 && (
                      <IconButton
                        className="ml-4 vertical-middle" icon={DeleteIcon}
                        action={() => handleRemoveMapping(d, item)}
                      />
                    )}
                  </p>
                );
              })
            )
          );
        }
      },
      {
        title: "거래처명",
        key: "name",
      },
      {
        title: "거래처코드",
        key: "code",
      },
      {
        title: "대표자명",
        key: "ceoName",
      },
      {
        title: "구분",
        key: "type",
        onTranslator: {
          list: CLIENT_TYPES,
        },
      },
      {
        title: "사업자등록번호",
        key: "comNum",
        transform: "comNum",
      },
      { title: "주소", key: "address" },
      {
        title: "전화번호",
        key: "mobile",
      },
      {
        title: "사용여부",
        key: "isUse",
        onValue: (value) => {
          if (Number(value) === 1) {
            return (<>사용</>);
          } else if (Number(value) === 0) {
            return (<>중지</>);
          } else {
            return (<>-</>);
          }
        }
      },
    ]);
  }, []);

  useEffect(() => {
    previewClient === null && reSubmit();
  }, [previewClient]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list,
    setList,
    selectedList,
    setSelectedList,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
    reSubmit,
  } = useForm({
    searchType: "name",
    searchText: "",
    groupName: "",
    order: [
      {
        idx: "desc",
      },
    ],
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    if (targetPermission) {
      submit(form);
      setSubmit(submit);
    }
  }, [targetPermission]);

  const submit = (params) => {
    getAccountsAllList(getParams(params))
      .then((res) => {
        setTotal(get(res, "data.count"));
        setList(
          get(res, "data.accounts").map((client) => ({
            ...client,
            businessLicenseFile: get(client, "uploadFiles"),
          }))
        );
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
        setSelectedList([]);
      });
  };

  /*
  const tableButtons = [
    {
      label: "삭제",
      color: "gray-line",
      action: () => {
        if (selectedList.length === 0) {
          systemAlert("거래처를 선택해주세요.");
          return;
        }
        const title =
          selectedList.length === 1
            ? `"${selectedList[0].name}" 거래처를 삭제하시겠습니까?`
            : `${selectedList.length}개 거래처를 삭제하시겠습니까?`;
        systemAlert(title, {
          buttons: [
            {
              color: "text",
              label: "취소",
            },
            {
              label: "삭제",
              onClick: () => {
                viewLoading(true);
                deleteAccounts(selectedList.map((c) => c.idx)).finally(() => {
                  viewLoading(false);
                  setSelectedList([]);
                  submit(form);
                });
              },
            },
          ],
        });
      },
      disabled: isEmpty(selectedList),
    },
  ];
  */

  const headerButtons = [
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "wecake 엑셀업로드",
      color: "gray-line",
      action: () => {
        setFileUploadOpen(true);
      },
    },
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "타솔루션 엑셀업로드",
      color: "gray-line",
      action: () => {
        setOtherFileUploadOpen(true);
      },
    },
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        viewLoading(true);
        getAccountsDownloadExcel(getParams(form, true)).then((res) => {
          viewLoading(false);
          downExcelFile(res, "거래처_목록.xlsx");
        });
      },
    },
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "거래처 추가",
      action: () => {
        setDetailOpen(true);
      },
    },
  ];
  const openDetail = (data, e) => {
    // setDetailOpen(true);
    // setSelectedClient(data);
    const { tagName } = e.target;
    if (tagName !== "TR" && tagName !== "TD") return;
    clientPreview(data.idx);
  };

  return (
    !isEmpty(targetPermission) && (
      <>
        <PageHeader title={"거래처 정보 관리"} buttons={headerButtons}
        // activeTab={activeTab}
        // tabList={tabList}
        />
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          //isControl={targetPermission.level > 1}
          fields={fields}
          list={list}
          //buttons={targetPermission.level > 1 ? tableButtons : []}
          selectedList={selectedList}
          setSelected={setSelectedList}
          isLoading={isLoading}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          onSelect={openDetail}
          submit={handleSubmit}
        />
        <Client
          permission={targetPermission}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          open={detailOpen}
          setOpen={setDetailOpen}
          submit={reSubmit}
        />
        <ClientFileUpload
          open={fileUploadOpen}
          setOpen={setFileUploadOpen}
          filterSubmit={filterSubmit}
        />
        <ClientOtherFileUpload
          open={otherFileUploadOpen}
          setOpen={setOtherFileUploadOpen}
          filterSubmit={filterSubmit}
        />
      </>
    )
  );
};

export default Clients;
